export function getMimeTypeFromExt(ext: string) {
    switch ((ext || '').toLowerCase()) {
        case 'pdf': return 'application/pdf';
        case 'doc': return 'application/msword';
        case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        default: return 'application/octet-stream';
    }
}

export function makeFakeFileFromApi(cv: any): File {
    try {
        const fakeFile = new File([''], cv.name, {
            type: getMimeTypeFromExt(cv.ext),
            lastModified: cv.uploaded ? new Date(cv.uploaded).getTime() : Date.now(),
        });
        // @ts-ignore
        fakeFile.downloadUrl = cv.downloadUrl;
        // @ts-ignore
        fakeFile.size = cv.size;
        // @ts-ignore
        fakeFile.isApiFile = true;
        return fakeFile;
    } catch (e) {
        return {
            ...cv,
            name: cv.name,
            size: cv.size,
            lastModified: cv.uploaded ? new Date(cv.uploaded).getTime() : Date.now(),
            type: getMimeTypeFromExt(cv.ext),
            downloadUrl: cv.downloadUrl,
            isApiFile: true,
        } as any as File;
    }
}
